const tokenMintStages = [
    {
        name: 'sign',
        title: 'Signing transaction',
        content: 'Please sign using your wallet',
    },
    {
        name: 'wait',
        title: 'Waiting for transaction mining',
        content: 'Updating data in the blockchain',
        doneContent: 'Data has been uploaded to the blockchain',
    },
    {
        name: 'confirm',
        title: 'Confirmation',
        content: 'Transaction have been successfully confirmed',
    },
];

const tokenDeleteStages = [
    {
        name: 'sign',
        title: 'Signing transaction',
        content: 'Please sign using your wallet',
    },
    {
        name: 'wait',
        title: 'Waiting for transaction mining',
        content: 'Updating data in the blockchain',
        doneContent: 'Data has been uploaded to the blockchain',
    },
    {
        name: 'confirm',
        title: 'Confirmation',
        content: 'Transaction have been successfully confirmed',
    },
];
const tokenTransferStages = [
    {
        name: 'sign',
        title: 'Signing transaction',
        content: 'Please sign using your wallet',
    },
    {
        name: 'wait',
        title: 'Waiting for transaction mining',
        content: 'Uploading data to the blockchain',
        doneContent: 'Data has been uploaded to the blockchain',
    },
    {
        name: 'confirm',
        title: 'Confirmation',
        content: 'Transaction have been successfully confirmed',
    },
];
const tokenContractStages = [
    {
        name: 'sign',
        title: 'Signing transaction',
        content: 'Please sign using your wallet',
    },
    {
        name: 'wait',
        title: 'Waiting for transaction mining',
        content: 'Uploading data to the blockchain',
        doneContent: 'Data has been uploaded to the blockchain',
    },
    {
        name: 'confirm',
        title: 'Confirmation',
        content: 'Transaction have been successfully confirmed',
    },
];
export { tokenMintStages, tokenDeleteStages, tokenTransferStages, tokenContractStages };
